import React , { useState }from 'react';
import { ObtenerCertificadoPersonaPrograma } from '../../../services/UsuarioService';
import { CertificadoFProgramaEspecializacionNotas } from '../../../services/CertificadosServices';
import "./CardDownload.scss"
import iconDownload from "../../../assets/img/interna/download.png";
import useAlumno from "../../../hooks/useAlumno";
import { handleDownloadCertificado, urlToShare } from '../../../helpers/helpers';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { PrivateRoutes } from '../../../routes/routes';
import * as constantes from "../../../constants/constantes.js";

function CardDownloadPrograma({ listaCursoPrograma, listaEvaluacionesUnidadeCursoPrograma, Persona, programa, 
    listaUnidadeCursoPrograma,setspinnerCertificado,spinnerCertificado,ProgressSpinner,setspinnerNotas,spinnerNotas,
    PersonaProgamaData }) {
    
    const navigate = useNavigate();
    const {idCurso} = useParams();
    let { configuraciones } = useAlumno();
    const [isButtonDisabledCertificado, setButtonDisabledCertificado] = useState(false);
    const [isButtonDisabledNotas, setButtonDisabledNotas] = useState(false);

    const handleDownloadNotasPrograma = async () => {
        let jwt = window.localStorage.getItem("jwt");
        const currentDate = new Date();
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}_${String(currentDate.getMonth() + 1).padStart(2, '0')}_${String(currentDate.getFullYear()).slice(-2)}`;
        let IDPersonaPrograma = listaCursoPrograma[0].idPersonaPrograma;
        ObtenerCertificadoPersonaPrograma({ jwt, IDPersonaPrograma }).then(async (dataCert) => {
            let jwt = window.localStorage.getItem("jwt");
            let nombrealumno =
                Persona.nombres +
                " " +
                Persona.primerApellido +
                " " +
                Persona.segundoApellido;
            let nombrecursoprograma = programa.nombre;
            let ubicacion = "Lima";
            let enlace = urlToShare //dataCert.LinkCDN
                ? `${urlToShare}${Persona.primerApellido.trim()}-${formattedDate.trim()}-${"DN_"+dataCert.codigoCertificado.split('-').slice(1, 3).join('-').trim()}.pdf`
                : '';
            const fileName = `${Persona.primerApellido.trim()}-${formattedDate.trim()}-${"DN_"+dataCert.codigoCertificado.split('-').slice(1, 3).join('-').trim()}`;
            const codigo = dataCert.codigoCertificado;
            const enlaceQR = constantes.URL_CERTIFICATE +"/ValidateCertificateQR?codigo="+ dataCert.codigoCertificado + "&tipo=2";
            let promedionotaD = 0;
            var detalle = [];
            for (var i = 0; i < listaCursoPrograma.length; i++) {
                var unidadesDat = listaUnidadeCursoPrograma.filter(
                    (x) => x.idCurso === listaCursoPrograma[i].idCurso
                );
                let notaMasAlta = 0;
                for (var j = 0; j < unidadesDat.length; j++) {
                    var evaluacionesUnidad = listaEvaluacionesUnidadeCursoPrograma.filter(
                        (x) => x.idUnidad === unidadesDat[j].idUnidad
                    );
                    let notas;
                    if (evaluacionesUnidad.length > 0) {
                        notas = evaluacionesUnidad.map((evaluacion) => evaluacion.nota);
                        notaMasAlta = notaMasAlta + Math.max(...notas);
                    }
                }
                notaMasAlta = notaMasAlta / unidadesDat.length;
                let detalleUnidad = {
                    nombremodulo: listaCursoPrograma[i].curso.nombre,
                    promedio: notaMasAlta.toFixed(0),
                    orden: i + 1,
                };
                promedionotaD = promedionotaD + notaMasAlta;
                detalle.push(detalleUnidad);
            }
            promedionotaD = (promedionotaD.toFixed(0) / listaCursoPrograma.length).toFixed(0);
            let promedionota = promedionotaD.toString();
            let jsonData = JSON.stringify({
                nombrealumno,
                nombrecursoprograma,
                ubicacion,
                enlace,
                enlaceQR,
                codigo,
                promedionota,
                detalle,
            });
            const dataCDN = {
                Extension: enlace.split('.').pop(),
                NombreCDN: fileName
            };
            try {
                setspinnerNotas(true)
                setButtonDisabledNotas(true)
                const response = { link: enlace, fileName };
                await CertificadoFProgramaEspecializacionNotas({ jwt, jsonData, dataCDN, response }).then(
                    (data) => { }
                );
                setButtonDisabledNotas(false)
                setspinnerNotas(false)
            } catch (error) {
                setspinnerNotas(false)
                alert.error(
                    "Error en la función CertificadoFProgramaEspecializacionNotas:",
                    error
                );
            }
        })
    };

const onDownloadCertificadoPrograma = async() => {
      
  try{

    navigate("/" + PrivateRoutes.HOME + "/ShareCertificate/Program/" + PersonaProgamaData.idPrograma + "/" + PersonaProgamaData.idPersonaPrograma  + "/" +  idCurso,{
      state: {downloading:true}
    });
      
    const res = await handleDownloadCertificado({
          cursoPersona: PersonaProgamaData,
          listaCursoPrograma: listaCursoPrograma,
          programa: programa,
          persona: Persona,
          tipo:"Program"
    });

      console.log('urlCertificado',res)
    navigate("/" + PrivateRoutes.HOME + "/ShareCertificate/Program/" + PersonaProgamaData.idPrograma + "/" + PersonaProgamaData.idPersonaPrograma  + "/" + idCurso,{
        state: {downloading:false, res}
    });
  }catch(error){
      toast.error(error,{ autoClose: 3000})
  }
};

    function programaEstadoEvaluacionResultados() {
        var promedio = 0;
        let band = true;
        if (listaCursoPrograma) {
            listaCursoPrograma.forEach(element => {
                if (element.idEstado != 1 || element.idCondicion == 2) {
                    band = false;
                }
                promedio = parseFloat(promedio) + parseFloat(calcularPromedioNotasPorUnidad(element.idCurso));
            });
        }
        if (band) {
            if (promedio < configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return band
        }

    }
    function calcularPromedioNotasPorUnidad(idCurso) {
        if (listaEvaluacionesUnidadeCursoPrograma) {
            var unidades = listaUnidadeCursoPrograma.filter(
                (x) => x.idCurso === idCurso
            );
            var promediototal = 0;
            for (var k = 0; k < unidades.length; k++) {
                if (listaEvaluacionesUnidadeCursoPrograma.length > 0) {
                    var evaluacionesUnidad = listaEvaluacionesUnidadeCursoPrograma.filter(
                        (x) => x.idUnidad === unidades[k].idUnidad
                    );
                    if (evaluacionesUnidad.length > 0) {
                        const notas = evaluacionesUnidad.map(
                            (evaluacion) => evaluacion.nota
                        );
                        const notaMasAlta = Math.max(...notas);
                        promediototal = promediototal + notaMasAlta;
                    }
                }
            }
            promediototal = promediototal / unidades.length;
            return promediototal.toFixed(2);
        } else {
            return 0;
        }
    }

    let visible = "flex align-items-center justify-content-center interna-material-download"
    let noVisible = "flex align-items-center justify-content-center interna-material-download-apagado"

    return (
        <div className="p-fluid formgrid grid progreso-mobile ">


            <div className="flex interna-material w-full mb-2">
                <div className="interna-material-info card__download__programa">
                    <span className=" text-sm h3" data-v-48f3e599="">
                        Certificado del programa
                    </span>
                </div>
                <div
                    className={
                        listaCursoPrograma && listaEvaluacionesUnidadeCursoPrograma && programaEstadoEvaluacionResultados() && isButtonDisabledCertificado == false
                            ? visible
                            : noVisible
                    }
                    style={{
                        width: "77px",
                        height: "100%",
                    }}
                    onClick={() => {
                        if (
                            listaCursoPrograma && listaEvaluacionesUnidadeCursoPrograma && programaEstadoEvaluacionResultados()
                        ) {
                            onDownloadCertificadoPrograma();
                        }
                    }}
                >
                    {spinnerCertificado ? (
                        <ProgressSpinner
                            style={{ width: "50px", height: "50px" }}
                        />
                    ) : (
                        <img
                            src={iconDownload}
                            width={"17.5px"}
                            height={"21px"}
                        ></img>
                    )}
                </div>
            </div>

            <div className="flex interna-material w-full mb-2">
                <div className="interna-material-info card__download__programa">
                    <span className=" text-sm h3" data-v-48f3e599="">
                        Detalle de notas del programa
                    </span>
                </div>
                <div
                    className={
                        listaCursoPrograma && listaEvaluacionesUnidadeCursoPrograma && programaEstadoEvaluacionResultados()  && isButtonDisabledNotas == false
                            ? visible
                            : noVisible
                    }
                    style={{
                        width: "77px",
                        height: "100%",
                    }}
                    onClick={() => {
                        if (
                            listaCursoPrograma && listaEvaluacionesUnidadeCursoPrograma && programaEstadoEvaluacionResultados()
                        ) {
                            handleDownloadNotasPrograma();
                        }
                    }}
                >
                     {spinnerNotas ? (
                        <ProgressSpinner
                            style={{ width: "50px", height: "50px" }}
                        />
                    ) : (
                        <img
                            src={iconDownload}
                            width={"17.5px"}
                            height={"21px"}
                        ></img>
                    )}
                </div>
            </div>
        </div>
    )
}

export default CardDownloadPrograma